<!-- 任务编辑页面 0 添加 1 编辑 2 查看明细 -->
<template>
    <div class="tasks-edit">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="section-title">
            <div>
                <span>拜访任务</span>
                <span v-if="submitData.TasksCode != ''">任务单号：{{ submitData.TasksCode }}</span>
                <span>【拜访客户数：{{ dataList.length }}】</span>
            </div>
            <div>
                <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm()" v-if="type != '2'" :disabled="stopSubmit">提交任务</el-button>
            </div>
        </div>
        <div class="order-infoes">
            <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="拜访类型" prop="TasksType">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.TasksTypeName"></el-input>
                                <el-select
                                    v-else
                                    v-model="submitData.TasksType"
                                    placeholder="请选择拜访类型"
                                    style="width: 100%"
                                    size="small"
                                    filterable
                                    clearable
                                    @visible-change="typeVisibleChange($event)"
                                    @change="typeChange($event)"
                                >
                                    <el-option v-for="item in tasksTypeList" :label="item.AttrName" :key="item.AttrValue" :value="item.AttrValue"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="跟进人" prop="FollowerId">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.Follower"></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    size="small"
                                    :disabled="submitData.TasksTypeName == '255'"
                                    v-model="submitData.FollowerId"
                                    filterable
                                    clearable
                                    @visible-change="followerVisibleChange($event)"
                                    placeholder="请选择跟进人"
                                >
                                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="开始时间" prop="StartTime">
                                <el-date-picker
                                    style="width: 100%"
                                    size="small"
                                    :disabled="dataReadonly"
                                    v-model="submitData.StartTime"
                                    type="date"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="结束时间" prop="EndTime">
                                <el-date-picker
                                    style="width: 100%"
                                    size="small"
                                    :disabled="dataReadonly"
                                    v-model="submitData.EndTime"
                                    type="date"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="14">
                        <div class="grid-content bg-purple">
                            <el-form-item label="备注" prop="Remark">
                                <el-input size="small" v-model="submitData.Remark" :disabled="dataReadonly"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="section-title">
            <div>
                <span>拜访清单</span>
            </div>
            <div>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="!dataReadonly">选择客户</el-button>
            </div>
        </div>
        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: true }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65"></ux-table-column>
                <ux-table-column field="Tags" title="标签类型" width="100" key="Tags">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Tags }}</div>
                    </template>
                </ux-table-column>             
                <ux-table-column field="CustName" title="客户名称" resizable v-if="dataReadonly">
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" :content="row.CustName ? row.CustName.toString() : ''"  placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.CustName }]">{{ row.CustName }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="CustName" title="客户名称" edit-render resizable v-else>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.CustName ? row.CustName.toString() : ''" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.CustName }]" @click="focusHandle('custSelect')">
                                {{ row.CustName }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="custSelect"
                            style="width: 100%"
                            allow-create
                            size="small"
                            v-model="scope.row.CustName"
                            :title="scope.row.CustName"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="请选择客户"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row);
                                }
                            "
                            v-select-scroll-more="searchAutoSerieLoad"
                            @change="custChange($event, scope.rowIndex)"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'CustName')"
                            @keyup.right.native="keyEvent($event, 'CustName')"
                            @keyup.left.native="keyEvent($event, 'CustName')"
                        >
                            <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">{{ option.AutoSerise }}</div>
                                    <div class="project-Name">{{ option.GoodName }}</div>
                                    <div class="project-Name">{{ option.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ option.GoodCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                 <ux-table-column field="PhoneNum" title="联系电话" width="100" key="PhoneNum">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.PhoneNum }}</div>
                    </template>
                </ux-table-column>   
                 <ux-table-column field="Address" title="详细地址" :edit-render="{ autofocus: '.el-input__inner' }" key="Address">
                    <template v-slot:header="{ column }">{{ column.title }}</template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.Address }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="addressSelect"
                            allow-create
                            :disabled="dataReadonly"
                            size="small"
                            v-model="scope.row.Address"
                            filterable
                            clearable
                            reserve-keyword
                            placeholder="详细地址"
                            @keyup.enter.native="keyEvent($event, 'Address')"
                            @keyup.left.native="keyEvent($event, 'Address')"
                        >
                            <el-option v-for="option in scope.row.AddressList" :key="option.Value" :data-msg="option" :label="option.Text" :value="option.Text">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 150px">{{ option.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>                              
                <ux-table-column field="ItemRemark" title="本次备注" :edit-render="{ autofocus: '.el-input__inner' }" key="ItemRemark">
                    <template v-slot:header="{ column }">{{ column.title }}</template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.ItemRemark }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell" >
                            <el-input
                                ref="itemRemarkRef"
                                size="small"
                                :disabled="dataReadonly"
                                v-model="scope.row.ItemRemark"
                                placeholder=" 备注"
                                @keyup.enter.native="keyEvent($event, 'ItemRemark')"
                                @keyup.left.native="keyEvent($event, 'ItemRemark')"
                            ></el-input>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type != 0 && type != 1">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex)"
                                icon="el-icon-delete"
                                v-if="!dataReadonly"
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="rowIndex + 1 === dataList.length && !dataReadonly"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>

        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            needConfirm: true,
            dataReadonly: false,
            loading: false,
            type: '0', //0 添加 1 编辑 2 查看明细
            pageTitle: '',
            submitData: {
                TaskId: '',
                TasksType: '',
                TasksTypeName: '',
                TaskName: '',
                FollowerId: '',
                Follower: '',
                StartTime: '',
                EndTime: '',
                Remark: '',
                TasksItems: []
            },
            rules: {
                TasksType: [{ required: true, message: '请选择拜访类型', trigger: 'blur' }],
                FollowerId: [{ required: !(submitData && submitData.TasksType == '255'), message: '请选择跟进入', trigger: 'blur' }]
            },
            tasksTypeList: [],
            SIdList: [],
            dataList: []
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            return this.infiniteListHeight - 24;
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    created() {
        this.type = this.$route.query.type;
    },
    mounted() {
        let that = this;
        that.submitData.TaskId = that.$route.query.id;
        switch (that.type) {
            case '0':
                that.pageTitle = '创建拜访任务';
                that.addItem();
                break;
            case '1':
                that.pageTitle = '编辑拜访任务';
                that.getTaskDetail();
                break;
            case '2':
                that.pageTitle = '查看拜访任务';
                that.dataReadonly = true;
                that.needConfirm = false;
                that.getTaskDetail();
                break;
        }
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        // 监听滚动事件
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    methods: {
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        typeVisibleChange(event) {
            let that = this;
            if (event && (!that.typeVisible || that.typeVisible.length <= 1)) {
                that.getTaskTypeList();
            }
        },
        typeChange(val) {
            let that = this;
            if (val == '255') {
                that.submitData.FollowerId = '';
                that.submitData.Follower = '';
            }
        },
        getTaskTypeList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpAttrDatas?attrCode=tasksType'
                })
                .then(res => {
                    if (res.data) {
                        this.tasksTypeList = res.data;
                        this.tasksTypeList.push({ AttrCode: 'tasksType', AttrName: '助力外拓', AttrValue: '255' });
                    } else {
                        this.tasksTypeList = [];
                    }
                });
        },
        followerVisibleChange() {
            let that = this;
            if (event && (!that.SIdList || that.SIdList.length <= 1)) {
                that.getSIdList();
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        getTaskDetail() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetVisitingTasksDetail',
                    data: {
                        TaskId: that.submitData.TaskId
                    }
                })
                .then(res => {
                    let data = res.data;
                    that.tasksTypeList.push({
                        AttrValue: data.TasksType,
                        AttrName: data.TasksTypeName
                    });
                    that.SIdList.push({
                        EmployeeId: data.FollowerId,
                        EmployeeName: data.Follower
                    });
                    that.submitData = data;
                    that.dataList = data.TasksItems;
                    if (that.type == '1') {
                        this.addItem();
                    }
                })
                .catch(error => {});
        },
        // 删除某行
        delItem(index) {
            this.dataList.splice(index, 1);
        },
        // 添加一行
        addItem() {
            if (this.type * 1 === 0) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].CustId) {
                    this.$util.warningMsg('请选择客户');
                    return;
                }
            }

            this.dataList.push({
                ItemId: '',
                CustId: '',
                CustName: '',
                Address: '',
                PhoneNum: '',
                ItemRemark: ''
            });

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('elx-table--body-wrapper')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            //选中编码下拉框
            let that = this;
            that.$nextTick(() => {
                setTimeout(function() {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
             let   rowArr = this.dataList.filter(f => f.CustId === row.CustId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
         // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    if (this.$refs[`sapcode`]) {
                        this.$refs[`sapcode`].focus();
                    }
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    if (this.$refs[`partsNameSelect`]) {
                        this.$refs[`partsNameSelect`].focus();
                    }
                }, 200);
            }
            if (type === 'custSelect') {
                setTimeout(() => {
                    if (this.$refs[`custSelect`]) {
                        this.$refs[`custSelect`].focus();
                    }
                }, 200);
            }
        },
    }
};
</script>
<style lang="less" scoped>
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;

    span {
        margin-right: 20px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    padding-top: 30px;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
</style>
<style lang="less">
.tasks-edit {
    width: 100%;
    padding: 10px 20px 0px 20px;

    .order-infoes {
        border: 1px solid @border3Color;
        padding-top: 10px;
        margin-bottom: 10px;

        .grid-content {
            border-radius: 4px;
            min-height: 32px;
        }
        .el-form-item {
            margin-bottom: 0px;
            line-height: 32px;
            height: 32px;
        }

        .el-form-item__label {
            line-height: 32px;
            height: 32px;
        }

        .el-form-item__content {
            line-height: 32px !important;
            height: 32px;
            top: -1px;
        }
    }
    .el-row {
        margin-bottom: 10px !important;

        &:last-child {
            margin-bottom: 10px !important;
        }
    }

    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 220px !important;

            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .table-check {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 10px;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
</style>
